import { CSS, Spacing, StyleProps } from "@shared/primitive-components"
import { CompleteSpeedBands } from "../../api/insights"

const width = (value: number, extended: boolean | undefined) => `${extended ? 256 * value : 155 * value}%`

export const fullWidth = (): CSS => ({
  width: `100%`,
})

export const marginBottom =
  (margin: Spacing) =>
  (props: StyleProps): CSS => ({
    marginBottom: props.theme.spacing(margin),
  })

export const lawfulPercentageLine =
  (speedBands: CompleteSpeedBands, extended: boolean | undefined) => (props: StyleProps) => ({
    height: props.theme.spacing(2),
    width: width(speedBands.lawfulSpeedBandPercentage, extended),
    backgroundColor: props.theme.palette.full.green,
    display: speedBands.lawfulSpeedBandPercentage ? `block` : `none`,
  })

export const minorPercentageLine =
  (speedBands: CompleteSpeedBands, extended: boolean | undefined) => (props: StyleProps) => ({
    height: props.theme.spacing(2),
    width: width(speedBands.minorSpeedBandPercentage, extended),
    backgroundColor: props.theme.palette.full.amber,
    display: speedBands.minorSpeedBandPercentage ? `block` : `none`,
  })

export const majorPercentageLine =
  (speedBands: CompleteSpeedBands, extended: boolean | undefined) => (props: StyleProps) => ({
    height: props.theme.spacing(2),
    width: width(speedBands.majorSpeedBandPercentage, extended),
    backgroundColor: props.theme.palette.full.orange,
    display: speedBands.majorSpeedBandPercentage ? `block` : `none`,
  })

export const criticalPercentageLine =
  (speedBands: CompleteSpeedBands, extended: boolean | undefined) => (props: StyleProps) => ({
    height: props.theme.spacing(2),
    width: width(speedBands.criticalSpeedBandPercentage, extended),
    backgroundColor: props.theme.palette.full.red,
    display: speedBands.criticalSpeedBandPercentage ? `block` : `none`,
  })

const labelDimensions = (value: boolean, props: StyleProps) => ({
  display: value ? `block` : `none`,
  width: props.theme.spacing(2),
  height: props.theme.spacing(2),
  marginRight: value ? props.theme.spacing(1) : 0,
})

export const lawfulPercentageLineLabel =
  (value: boolean) =>
  (props: StyleProps): CSS => ({
    ...labelDimensions(value, props),
    backgroundColor: props.theme.palette.full.green,
  })

export const minorPercentageLineLabel =
  (value: boolean) =>
  (props: StyleProps): CSS => ({
    ...labelDimensions(value, props),
    backgroundColor: props.theme.palette.full.amber,
  })

export const majorPercentageLineLabel =
  (value: boolean) =>
  (props: StyleProps): CSS => ({
    ...labelDimensions(value, props),
    backgroundColor: props.theme.palette.full.orange,
  })

export const criticalPercentageLineLabel =
  (value: boolean) =>
  (props: StyleProps): CSS => ({
    ...labelDimensions(value, props),
    backgroundColor: props.theme.palette.full.red,
  })

export const labelText =
  (value: boolean) =>
  (props: StyleProps): CSS => ({
    display: value ? `block` : `none`,
    marginRight: value ? props.theme.spacing(2) : 0,
  })
